/// <reference types="vite-plugin-svgr/client" />

import alignLeftIcon from './align-left.svg?react';
import alignCenterIcon from './align-center.svg?react';
import alignRightIcon from './align-right.svg?react';
import alignJustifyIcon from './align-justify.svg?react';
import backgroundIcon from './background.svg?react';
import blockquoteIcon from './blockquote.svg?react';
import boldIcon from './bold.svg?react';
import cleanIcon from './clean.svg?react';
import closeIcon from './close.svg?react';
import codeIcon from './code.svg?react';
import colorIcon from './color.svg?react';
import directionLeftToRightIcon from './direction-ltr.svg?react';
import directionRightToLeftIcon from './direction-rtl.svg?react';
import formulaIcon from './formula.svg?react';
import headerIcon from './header.svg?react';
import header2Icon from './header-2.svg?react';
import italicIcon from './italic.svg?react';
import imageIcon from './image.svg?react';
import indentIcon from './indent.svg?react';
import outdentIcon from './outdent.svg?react';
import linkIcon from './link.svg?react';
import listBulletIcon from './list-bullet.svg?react';
import listCheckIcon from './list-check.svg?react';
import listOrderedIcon from './list-ordered.svg?react';
import subscriptIcon from './subscript.svg?react';
import superscriptIcon from './superscript.svg?react';
import strikeIcon from './strike.svg?react';
import tableIcon from './table.svg?react';
import underlineIcon from './underline.svg?react';
import videoIcon from './video.svg?react';
import docxIcon from './docx_icon.svg?react';
import odtIcon from './odt-icon.svg?react';

const config = {
  align: {
    left: alignLeftIcon,
    center: alignCenterIcon,
    right: alignRightIcon,
    justify: alignJustifyIcon,
  },
  background: backgroundIcon,
  blockquote: blockquoteIcon,
  bold: boldIcon,
  clean: cleanIcon,
  close: closeIcon,
  code: codeIcon,
  'code-block': codeIcon,
  color: colorIcon,
  direction: {
    '': directionLeftToRightIcon,
    rtl: directionRightToLeftIcon,
  },
  formula: formulaIcon,
  header: {
    '1': headerIcon,
    '2': header2Icon,
  },
  italic: italicIcon,
  image: imageIcon,
  indent: {
    '+1': indentIcon,
    '-1': outdentIcon,
  },
  link: linkIcon,
  list: {
    bullet: listBulletIcon,
    check: listCheckIcon,
    ordered: listOrderedIcon,
  },
  script: {
    sub: subscriptIcon,
    super: superscriptIcon,
  },
  strike: strikeIcon,
  table: tableIcon,
  underline: underlineIcon,
  video: videoIcon,
  docx: docxIcon,
  odt: odtIcon
};

export default config